<template>
  <div
    class="club-info-banner"
    :class="{
      'club-info-banner_fixed-bottom': fixedBottomValue,
    }"
    :style="{
      bottom: fixedBottomValue ? fixedBottomValue : 'initial',
    }"
    data-qa="club_info_banner"
    @click="handleClubInfoBannerClick"
  >
    <div
      v-if="discountOnServices"
      class="club-info-banner__price-discount"
      data-qa="club_info_banner_percent"
    >
      -{{ discountOnServices }}%
    </div>
    <div class="pr-10">
      <div
        class="text-subtitle-1 error--text"
        data-qa="club_info_banner_title"
      >
        {{ title }}
      </div>
      <div
        v-if="subtitle"
        class="text-body-2 text-secondary--text"
        data-qa="club_info_banner_subtitle"
      >
        {{ subtitle }}
      </div>
    </div>
    <span
      class="club-info-banner__icon error--text"
      :class="showInfoIcon ? 'ui-icon-circle-info' : 'ui-icon-arrow-right ui-icon-fz-medium'"
      :data-qa="`${showInfoIcon ? 'club_info_banner_icon_info' : 'club_info_banner_icon_arrow'}`"
    />
  </div>
</template>

<script>
import { dispatchCustomEventGlobally } from 'www/utils'

export default {
  name: 'ClubInfoBanner',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    showInfoIcon: {
      type: Boolean,
      default: false,
    },
    fixedBottomValue: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    discountOnServices: window.USER.club.discountOnServices,
  }),
  methods: {
    handleClubInfoBannerClick() {
      this.$emit('club-info-banner:click')
      dispatchCustomEventGlobally('club-info-banner:click')
    },
  },
}
</script>

<style scoped lang="scss">
@import '~www/themes/doctors/common/variables';

.club-info-banner {
  display: flex;
  align-items: center;
  border-radius: $border-radius-md;
  background-color: $ui-kit-bg-club;
  padding: 8px 12px;
  cursor: pointer;
  min-height: 47px;
  position: relative;

  &__price-discount {
    background-image: $ui-kit-club-gradient;
    border-radius: $border-radius-sm;
    color: $ui-kit-bg-gray-0;
    font-weight: $weight-medium;
    font-size: $font-size-subtitle-2;
    line-height: $line-height-base;
    letter-spacing: 0;
    padding: 2px 4px;
    margin-right: 12px;
  }

  &__icon {
    position: absolute;
    top: calc(50% - 12px);
    right: 12px;
  }

  &_fixed-bottom {
    z-index: 5;
    left: 8px;
    right: 8px;
    position: fixed;
  }
}
</style>
